// extracted by mini-css-extract-plugin
module.exports = {"shareButton":"shareButton-22cdA","header":"header-dNE_7","closeIcon":"closeIcon-3-SKA","buttons":"buttons-3IBPE","button":"button-EIy2Y"};